import React from "react";
import HistoryEduIcon from "@mui/icons-material/HistoryEdu";
import TableRowsOutlinedIcon from "@mui/icons-material/TableRowsOutlined";
import InteractionPropsDisplay from "../InteractionPropsDisplay";
import ContactPageIcon from '@mui/icons-material/ContactPage';

export interface InteractionTypeIndicatorProps {
  type: string;
  variant: string;
}

const InteractionTypeIndicator = (props: InteractionTypeIndicatorProps) => {
  let avatar: any = null;
  let label = "Type: ";
  switch (props.type) {
    case "cs1survey": {
      // for MVP, focusing on CS1 surveys
      avatar = <HistoryEduIcon style={{ color: "white" }} />;
      label = "Type: ";
      break;
    }
    case "task": {
      // TODO
      break;
    }
    case "alert": {
      // TODO
      break;
    }
    case "information": {
      // TODO
      break;
    }
    case "pathway": {
      avatar = <TableRowsOutlinedIcon style={{ color: "white" }} />;
      label = "Type: ";
      break;
    }
    case "account": {
      avatar = <ContactPageIcon style={{ color: "white" }} />;
      label = "";
      break;
    }
    default: {
      // interactionContent = <div>Interaction Type Not Properly Defined</div>;
      break;
    }
  }

  return (
    <InteractionPropsDisplay
      label={label}
      avatar={avatar}
      text={props.type}
      variant={props.variant}
    />
  );
};

export default InteractionTypeIndicator;
